import Random from '@/docs-partials/api/endpoints/random.mdx';
import * as React from 'react';
export default {
  Random,
  React
};